//@flow
import Collection from '../../Utils/Collection/baseCollection';
import CategoryModel from './categoryModel';
import type QuoteItemsCollection from '../Quote/quoteItemsCollection';
import type { CategoryObject } from './categoryModel';
import type { OrderItemObject } from '../Order/orderItemModel';
import _ from 'underscore';

export default class BaseCategoriesCollection extends Collection<CategoryObject, CategoryModel, {[string]:$Shape<CategoryObject>}>{
  catalogProducts:string[];

  __modelClass() {
    return CategoryModel;
  }

  +__primaryCategoryUrlKey:() => string;

  __parse(data:?{[string]:CategoryObject}):CategoryObject[] {
    const primaryCategoryUrlKey = this.__primaryCategoryUrlKey();
    const primaryCat:?CategoryObject = _.find(data, (cat) => cat.url_key === primaryCategoryUrlKey);
    if (!primaryCat) return [];

    this.catalogProducts = primaryCat.product_skus;
    if (!data) return [];
    const dataCopy = data;
    return primaryCat.child_categories
      .map(childId => dataCopy[childId])
      .filter(Boolean);
  }

  getCategoriesForProduct(sku:string):CategoryModel[] {
    return _.filter(this.models, (category) => {
      return category.getProductsSkus().indexOf(sku) > -1;
    });
  }

  findByUrlKey(urlKey:?string):?CategoryModel {
    return _.find(this.models, (model) => model.getUrlKey() === urlKey);
  }

  findById(id:string):?CategoryModel {
    return _.find(this.models, (model) => model.getId() === id);
  }

  getCatalogProducts():string[] {
    return this.catalogProducts || [];
  }

  getCategoriesByUrlKeys(urlKeys:string[]):CategoryModel[] {
    const categories = urlKeys.map((urlKey) => this.findByUrlKey(urlKey));
    return _.compact(categories);
  }

  hasSkuForUrlKey(urlKey:string, sku:string):boolean {
    const category = this.findByUrlKey(urlKey);
    if (!category) return false;
    return category.hasSku(sku);
  }

  hasQuoteItemForUrlKey(urlKey:string, quoteItems:?QuoteItemsCollection):boolean {
    const category = this.findByUrlKey(urlKey);
    if (!category) return false;
    return category.hasQuoteItem(quoteItems);
  }

  hasOrderItemForUrlKey(urlKey:string, orderItems:OrderItemObject[]):boolean {
    const category = this.findByUrlKey(urlKey);
    if (!category) return false;
    return category.hasOrderItem(orderItems);
  }

  getItemSkusForUrlKey(urlKey:string, items:OrderItemObject[]):string[] {
    const category = this.findByUrlKey(urlKey);
    return (category && category.getItemSkus(items)) || [];
  }

  getQuoteItemSkusForUrlKey(urlKey:string, quoteItems:QuoteItemsCollection):string[] {
    const category = this.findByUrlKey(urlKey);
    return (category && category.getQuoteItemSkus(quoteItems)) || [];
  }

  findByUrlKeys(urlKeys:string[]):CategoryModel[] {
    return this._getModelsByAttributes('url_key', urlKeys);
  }
}
